module.exports = __webpack_public_path__ + "static/media/PJ500.e8e113c7.jpg";